module.exports = __webpack_public_path__ + "static/media/guide_img1_2.b27e2b77.png";